// The in-app step before a change's passkey sign-in (37, Behaviour 3.1, v1.58.36): a small dialog
// named by the change, "Confirm with passkey" leaving for desyr ID, Cancel or Escape staying with
// nothing sent and nothing kept.
import { useEffect, useState } from 'react';
import { Confirm } from '../blocks/Dialog';
import { Said } from '../core/errors';
import { t } from '../i18n';

interface Ask {
  invite: boolean;
  go: () => Promise<void>;
  done: (left: boolean) => void;
}
let open: ((ask: Ask | undefined) => void) | undefined;

/** Cancelled at the step: the change's own dialog stays as it was, without words or a toast. */
export const stayed = new Said('');

/** Asks before `go` (the passkey sign-in): true once it is leaving, false when the person stays. */
export const confirmFirst = (invite: boolean, go: () => Promise<void>): Promise<boolean> =>
  open ? new Promise((done) => open!({ invite, go, done })) : go().then(() => true);

export function StepUpHost() {
  const [ask, setAsk] = useState<Ask>();
  useEffect(() => {
    open = setAsk;
    return () => void (open = undefined);
  }, []);
  if (!ask) return null;
  const close = (left: boolean) => (setAsk(undefined), ask.done(left));
  return (
    <Confirm
      narrow
      title={t(ask.invite ? 'id.stepInvite' : 'id.stepChange')}
      text={t('id.stepLine')}
      action={t('id.stepConfirm')}
      onConfirm={() => ask.go().then(() => close(true))}
      onClose={() => close(false)}
    />
  );
}
